export enum Identifiseringsmaate {
  ENTYDIG_IDENTIFISERT = 'identifiseringsmate.entydig',
  SAERSKILT_IDENTIFISERT = 'identifiseringsmate.sarskilt',
  TINGSINNBEGREP = 'identifiseringsmate.tingsinnbegrep',
  SAERSKILT_IDENTIFISERT_STRUKTURERT_MAAID = 'identifiseringsmate.sarskilt.strukturert.maaid',
  SAERSKILT_IDENTIFISERT_STRUKTURERT_AKSJER = 'identifiseringsmate.sarskilt.strukturert.aksjer',
}
